// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const onboardingAccessEffectSchema = z.object({
  "kind": z.enum(["parent_group", "application", "target"]),
  "id": z.string().uuid(),
  "name": z.string(),
  "selected_group_id": z.string().uuid().optional(),
  "selected_group_name": z.string().optional(),
  "via_group_id": z.string().uuid().optional(),
  "via_group_name": z.string().optional(),
  "source": z.enum(["direct", "inherited", "request", "all_people"]),
  "state": z.string(),
  "path": z.array(z.string())
});

export const onboardingGroupReviewSchema = z.object({
  "group_id": z.string().uuid(),
  "name": z.string(),
  "type": z.enum(["security", "role", "distribution"]),
  "ancestors": z.number().int().min(0),
  "applications": z.number().int().min(0),
  "connections": z.number().int().min(0),
  "digest": z.string()
});

export const onboardingInputRowSchema = z.object({
  "user_id": z.string().uuid().optional(),
  "display_name": z.string().max(512),
  "email": z.string().max(512),
  "given_name": z.string().max(512).optional(),
  "family_name": z.string().max(512).optional(),
  "department": z.string().max(512).optional()
}).strict();

export const onboardingRowSchema = z.object({
  "correction_batch_id": z.string().uuid().optional(),
  "number": z.number().int().min(1).max(200),
  "input": onboardingInputRowSchema,
  "action": z.enum(["create", "update"]),
  "state": z.enum(["pending", "invalid", "failed", "created", "updated"]),
  "message": z.string(),
  "user_id": z.string().uuid().optional(),
  "previous_display_name": z.string().optional(),
  "previous_given_name": z.string().optional(),
  "previous_family_name": z.string().optional(),
  "previous_department": z.string().optional(),
  "enrollment": z.enum(["not_created", "needs_pass", "pending", "expired", "enrolled", "unavailable"]),
  "csv_line": z.number().int().min(2).optional(),
  "original_row_number": z.number().int().min(1).max(200).optional(),
  "existing_group_ids": z.array(z.string().uuid())
});

export const onboardingBatchSchema = z.object({
  "id": z.string().uuid(),
  "digest": z.string(),
  "created_at": z.string().datetime({ offset: true }),
  "input_expires_at": z.string().datetime({ offset: true }).optional(),
  "minimized_at": z.string().datetime({ offset: true }).optional(),
  "expires_at": z.string().datetime({ offset: true }),
  "rows": z.array(onboardingRowSchema).max(200),
  "groups": z.array(onboardingGroupReviewSchema).max(5),
  "label": z.string().max(120),
  "created_by": z.string().uuid(),
  "stopped_at": z.string().datetime({ offset: true }).optional(),
  "stopped_by": z.string().uuid().optional(),
  "correction_of": z.string().uuid().optional(),
  "access_effects": z.array(onboardingAccessEffectSchema)
});

export const onboardingBatchSummarySchema = z.object({
  "id": z.string().uuid(),
  "created_at": z.string().datetime({ offset: true }),
  "total": z.number().int().min(0),
  "pending": z.number().int().min(0),
  "succeeded": z.number().int().min(0),
  "failed": z.number().int().min(0),
  "label": z.string().max(120),
  "created_by": z.string().uuid(),
  "stopped_at": z.string().datetime({ offset: true }).optional(),
  "expires_at": z.string().datetime({ offset: true })
});

export const onboardingBatchesSchema = z.object({
  "items": z.array(onboardingBatchSummarySchema).max(50),
  "next_cursor": z.string().uuid().optional()
});
